import(/* webpackMode: "eager" */ "/vercel/path0/src/page/root/components.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/page/root/sections/fitur.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/page/root/sections/hero.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/page/root/sections/kenapa_sipk.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/page/root/sections/mulai_sekarang.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/page/root/sections/universitas.jsx")